/**
 * Navigation service wrapping window.location methods.
 * This abstraction enables mocking in tests with Jest 30/JSDOM v26,
 * which makes window.location non-configurable.
 *
 * Note: window.location.assign() is used intentionally to preserve the referrer
 * for security purposes (see LoginRedirectWithRouter.tsx comments).
 */

/**
 * Navigate to a URL using window.location.assign().
 * Preserves the referrer, important for redirect loop detection.
 */
export const assign = (url: string): void => {
  window.location.assign(url);
};

/**
 * Navigate to a URL using window.location.replace().
 * Does NOT add an entry to browser history.
 */
export const replace = (url: string): void => {
  window.location.replace(url);
};

/**
 * Navigate by setting window.location.href directly.
 */
export const setHref = (url: string): void => {
  window.location.href = url;
};

export const getSearch = (): string => window.location.search;
export const getHash = (): string => window.location.hash;
export const getPathname = (): string => window.location.pathname;
export const getHref = (): string => window.location.href;
